/**
 * External dependencies
 */
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { __ } from '@wordpress/i18n';
import React, { useState } from 'react';

import { getPaymentMethodData } from '@woocommerce/settings';
import { decodeEntities } from '@wordpress/html-entities';
import { RawHTML } from '@wordpress/element';



/**
 * Internal dependencies
 */

const settings = getPaymentMethodData( 'redlight_swish', {} );
const defaultLabel = __( 'Swish', 'woocommerce-gateway-swish' );
const label = decodeEntities( settings?.title || '' ) || defaultLabel;

const LabelComponent = () => {

    return (
        <div>
            <img
                src={ settings.icon }
                alt={ label }
            />
        </div>
    );
};
const ContentComponent = ({
	billing,
	eventRegistration,
	emitResponse,
	components,
} ) => {
    const {onCheckoutSuccess} = eventRegistration;

    return (
        <>
            <RawHTML>
                {  settings.description || '' }
            </RawHTML>
        </>

    );
};

const canMakePayment = (billing) => {
    return billing.cartTotals.currency_code == 'SEK';
};

const swishPaymentMethod = {
    name: 'redlight_swish',
    label: <LabelComponent />,
    ariaLabel: __('Swish payment method', 'woocommerce-gateway-swish'),
    content: <ContentComponent />,
    edit: <ContentComponent />,
    canMakePayment,
    supports: {
        features: settings.supports ?? [],
    },
};

registerPaymentMethod(swishPaymentMethod);